<template>
  <div class="wrnt">
    <img :src="imgUrl + 'aliapp/20191012/mianya.jpg'" alt="大方租车 押金双免"/>
  </div>
</template>

<script>
import { imgUrl } from "@/utils/env";
export default {
  name: 'wrnt',
  data(){
    return {
      imgUrl: imgUrl,
    }
  },
  created () {},
  mounted () {},
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.wrnt {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
  }
}
</style>